module.exports = __webpack_public_path__ + "img/stone.8d56d91b.png";